import { render, staticRenderFns } from "./SuperUserRightsManagementShow.vue?vue&type=template&id=cf80ef38&scoped=true&"
import script from "./SuperUserRightsManagementShow.vue?vue&type=script&lang=js&"
export * from "./SuperUserRightsManagementShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf80ef38",
  null
  
)

export default component.exports